<ng-container *transloco="let tloco; prefix: 'subscriptions.billing.invoices'">
  <h2 class="m-0 pb-2 text-heading-2">{{ tloco('title') }}</h2>

  @if (invoices$ | async; as invoices) {
    <mat-divider class="md:hidden" />

    <mat-table class="hidden! md:block!" [dataSource]="invoices">
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef class="font-normal! text-steel-70!">{{ tloco('date') }}</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span>{{ row.TransitionFinalizedAt | date: 'd MMM yyyy' }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="subtotal">
        <mat-header-cell *matHeaderCellDef class="font-normal! text-steel-70!">{{ tloco('subtotal') }}</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span
            [innerHtml]="
              tloco('subtotal-value', {
                subtotal: row.SubTotal / 100 | currency,
                tax: row.Tax ? (row.Tax / 100 | currency) : undefined,
              })
            "
          ></span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef class="font-normal! text-steel-70!">{{ tloco('status') }}</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="bg-warning-10 px-1 py-0.5 text-button uppercase" [ngClass]="{ 'bg-success-10!': row.IsPaid }">{{
            row.IsPaid ? tloco('paid') : tloco('unpaid')
          }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="total">
        <mat-header-cell *matHeaderCellDef class="font-normal! text-steel-70!">{{ tloco('total') }}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.AmountTotal / 100 | currency }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="download">
        <mat-header-cell *matHeaderCellDef />
        <mat-cell *matCellDef="let row">
          @if (row.HostedInvoiceUrl) {
            <a [href]="row.HostedInvoiceUrl" mat-button target="_blank" color="primary">{{ tloco('view') }}</a>
          }
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="invoice">
        <mat-header-cell *matHeaderCellDef class="font-normal! text-steel-70!">{{ tloco('invoice') }}</mat-header-cell>
        <mat-cell *matCellDef="let row">
          @if (row.InvoiceNumber) {
            <span class="basis-full text-button">#{{ row.InvoiceNumber }}</span>
          }
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="['date', 'invoice', 'status', 'subtotal', 'total', 'download']" class="md:bg-steel-10!" />
      <mat-row *matRowDef="let row; columns: ['date', 'invoice', 'status', 'subtotal', 'total', 'download']" />
    </mat-table>

    <mat-table class="block! md:hidden!" [dataSource]="invoices">
      <ng-container matColumnDef="info">
        <mat-cell *matCellDef="let row" class="flex flex-col items-start text-center! py-4!">
          <span class="bg-warning-10 px-1 py-0.5 text-button uppercase" [ngClass]="{ 'bg-success-10!': row.IsPaid }">{{
            row.IsPaid ? tloco('paid') : tloco('unpaid')
          }}</span>
          <span>{{ row.TransitionFinalizedAt | date: 'd MMM yyyy' }}</span>
          @if (row.InvoiceNumber) {
            <span class="text-button">#{{ row.InvoiceNumber }}</span>
          }
          <span
            [innerHtml]="
              tloco('subtotal-value', {
                subtotal: row.SubTotal / 100 | currency,
                tax: row.Tax ? (row.Tax / 100 | currency) : undefined,
              })
            "
          ></span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="view">
        <mat-cell *matCellDef="let row" class="flex items-start justify-end py-4!">
          <div class="flex items-center">
            <span class="text-button">{{ row.AmountTotal / 100 | currency }}</span>
            @if (row.HostedInvoiceUrl) {
              <a [href]="row.HostedInvoiceUrl" mat-button target="_blank" color="primary">{{ tloco('view') }}</a>
            }
          </div>
        </mat-cell>
      </ng-container>
      <mat-row *matRowDef="let row; columns: ['info', 'view']" />
    </mat-table>
  } @else {
    <div class="flex justify-center rounded-md bg-steel-10 p-2">
      <span>{{ tloco('none') }}</span>
    </div>
  }
</ng-container>
